<template>
  <div
    class="order-items"
  >
    <ItemQty
      :quantity="packageQty"
      :maxqty="maxPackageQty"
      :updating="updating"
      candelete="false"
      @update-qty="emitPackageQty"
    />
  </div>
</template>

<script>
import { CurrencyApi } from '../../../default/currency_convert'
import ItemQty from '../../cart/order_items/version_1/item_quantity'

export default {

  components: {
    ItemQty
  },

  props: {
    packages: {
      default: () => [],
      required: true,
      type: Array
    },

    currency: {
      default: 'USD',
      required: true,
      type: String
    },

    rate: {
      default: 1.0,
      required: true,
      type: Number
    }
  },

  data() {
    return {
      packageQty: 1,
      selectedPackage: null,
      updating: false
    }
  },

  computed: {
    maxPackageQty() {
      return Math.min(this.selectedPackage.inventory_on_site, 10)
    }
  },

  watch: {
    packages() {
      this.refreshPackages()
    }
  },

  created() {
    //eslint-disable-next-line vue/no-mutating-props
    this.packages.sort(this.compareByPosition)
    this.refreshPackages()
  },

  methods: {
    emitPackageQty(pack = null) {
      if(!pack){
        pack = this.packageQty
      } else{
        this.packageQty = pack
      }
      this.$emit('qty-emit', pack)
    },

    formatPrice(pack){
      return CurrencyApi.formatAmount(pack.price * this.rate, this.currency)
    },

    compareByPosition(a, b){
      if (a.position > b.position) { return 1 }
      if (b.position > a.position) { return -1 }
    },

    refreshPackages() {
      this.selectedPackage = this.packages[0]
      this.resetPackageQty()
    },

    resetPackageQty() {
      this.$emit('package-emit', this.selectedPackage)
      if (this.selectedPackage.inventory_on_site < this.qtyPackage) {
        this.packageQty = 1
        this.emitPackageQty()
      }
    }
  }
}
</script>
